import {
  GET_USERINFO,
  GET_PLACES,
  GET_TALENTS,
  GET_TRADE,
  GET_WRCODE,
  GET_LOCALS,
  GET_TARGET,
  DEL_USERINFO,
  GET_USER_DIGEST
} from './mutation-types.js'

export default {
  [GET_USERINFO](state, userInfo) {
    state.userInfo = userInfo;
  },
  [GET_PLACES](state, placeObj) {
    state.placeObj = placeObj;
  },
  [GET_TALENTS](state, talentArr) {
    state.talentArr = talentArr;
  },
  [GET_TRADE](state, tradeObj) {
    state.tradeObj = tradeObj;
  },
  [GET_WRCODE](state, qrcode) {
    state.qrcode = qrcode;
  },
  [GET_LOCALS](state, localObj) {
    state.localObj = localObj;
  },
  [GET_TARGET](state, targetObj) {
    state.targetObj = targetObj;
  },
  [DEL_USERINFO](state, userInfo) {
    state.userInfo = userInfo;
  },
  [GET_USER_DIGEST](state, userDigest) {
    state.userDigest = userDigest;
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js